import { createTheme } from '@mui/material/styles';
import { customPalette } from './palette';
import { IThemeOptions } from './styles.interface';
export const brandonGrotesqueBold = 'BGBold';
export const brandonGrotesqueRegular = 'BGRegular';
export const defaultTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 700,
      lg: 1200,
      xl: 1536
    }
  },
  palette: {
    ...customPalette,
    secondary: {
      main: customPalette?.badge,
      light: customPalette?.cardBorder
    },
    primary: {
      main: customPalette?.themeColor,
      dark: customPalette?.primaryDark,
      contrastText: customPalette?.buttonFontColor,
      light: customPalette?.lightBlue
    },
    common: {
      white: '#ffffff',
      black: '#000000'
    }
  },
  typography: {
    h1: {
      fontSize: '28.5pt',
      lineHeight: '38pt',
      fontWeight: 700,
      wordBreak: 'break-word',
      color: customPalette?.themeColor,
      fontFamily: 'Georgia',
      fontStyle: 'normal'
    },
    h2: {
      fontSize: '18pt',
      lineHeight: '24pt',
      fontWeight: 700,
      color: customPalette?.themeColor,
      fontFamily: 'Georgia',
      fontStyle: 'normal'
    },
    h3: {
      fontSize: '13.5pt',
      lineHeight: '18pt',
      fontWeight: 700,
      color: customPalette?.themeColor,
      fontFamily: 'Georgia',
      fontStyle: 'normal'
    },
    h4: {
      fontSize: '12pt',
      lineHeight: '15pt',
      color: customPalette?.themeColor,
      letterSpacing: '0.45pt',
      fontWeight: 700,
      fontFamily: 'Georgia'
    },
    h5: {
      fontSize: '10.5pt',
      lineHeight: '15pt',
      fontWeight: 450,
      color: customPalette?.themeColor,
      letterSpacing: '0.45pt',
      fontFamily: brandonGrotesqueBold
    },
    body1: {
      fontWeight: 390,
      fontSize: '13.5pt',
      lineHeight: '18pt'
    },
    body2: {
      fontWeight: 390,
      fontSize: '10.5pt',
      lineHeight: '15pt'
    },
    subtitle1: {
      fontWeight: 450,
      fontSize: '13.5pt',
      lineHeight: '18pt',
      fontFamily: brandonGrotesqueBold
    },
    fontFamily: 'BGBold',
    allVariants: {
      color: customPalette.defaultFontColor
    }
  }
} as IThemeOptions);

const { breakpoints, typography } = defaultTheme;

//override for mobile view
export const theme = {
  ...defaultTheme,
  typography: {
    ...typography,
    h1: {
      ...typography.h1,
      [breakpoints.down('sm')]: {
        fontSize: '18pt',
        lineHeight: '24pt'
      }
    },
    h2: {
      ...typography.h2,
      [breakpoints.down('sm')]: {
        fontSize: '16pt',
        lineHeight: '24pt'
      }
    }
  },
  components: {}
};
